window.addEventListener("load", () => {
  const elements = document.querySelectorAll(".toggle-overlay-dashboard");

  elements.forEach((el) => {
    el.addEventListener("click", () => {
      const main = document.querySelector("#main");
      if (!main) {
        return;
      }

      main.classList.toggle("is-dashboard-visible");
    });
  });
});
